import React, { useEffect, useState } from 'react';
import { mainBgColor, mainBodyHeight, mainPadd, pageCommonGap1, pageCommonPadd, pageH1FontSize, pagePaddTopH } from '../constraints/AdminConst';
import Container from 'layouts/container/Container';
import VerticalFlex from 'layouts/flex/VerticalFlex';
import FlexChild from 'layouts/flex/FlexChild';
import P from 'components/P';

import AdminMobileSearchInput from 'routes/adminMobile/components/common/AdminMobileSearchInput';
import AdminMobileRegisterBtn from 'routes/adminMobile/components/common/AdminMobileRegisterBtn';
import AdminMobileNoticeList from 'routes/adminMobile/components/AdminMobileNoticeList';

// 공지사항 테스트 데이터
import testNoticeData from 'routes/adminMobile/commonVar/testNoticeData';
import { requester } from 'App';

const AdminMobileStoreNotice = () => {
    // 검색어 상태 추가
    const [searchKeyword, setSearchKeyword] = useState('');
    const [isMounted, setMounted] = useState(false);
    const [noticeList, setNoticeList] = useState([]);


    // 필터링된 공지사항 리스트를 상태로 관리
    const [filteredNotice, setFilteredNotice] = useState([]);

    // 검색 컴포넌트 기능
    // 검색어 입력 핸들러
    const handleSearchChange = (inputValue) => {
        setSearchKeyword(inputValue);
    };

    // 삭제 진행후 업데이트
    const handleUpdateNoticeList = (updatedNotices) => {
        setFilteredNotice(updatedNotices); 
    };
    useEffect(() => {
        setMounted(true);
    }, [])


    useEffect(() => {
        if (isMounted) {
            requester.findAllNotice((result) => {
                setNoticeList(result.data)
                console.log(result.data)
            })
        }
    }, [isMounted]);





    useEffect(() => {
        let filtered = noticeList;
    
        
        if (searchKeyword) {
            filtered = filtered.filter(notice => 
                notice.title && 
                notice.title.toLowerCase().includes(searchKeyword.toLowerCase())
            );
        }
    
        setFilteredNotice(filtered);
    }, [searchKeyword, noticeList]);
    
    




    return (
        <div style={{ paddingTop: pagePaddTopH }}>
            <Container padding={pageCommonPadd} height={mainBodyHeight}>
                <VerticalFlex gap={pageCommonGap1} backgroundColor={mainBgColor}>
                    <FlexChild alignItems="flex-start" height={"initial"} padding={mainPadd}>
                        {/* H1 헤더 */}
                        <P size={pageH1FontSize}>공지 관리</P>
                    </FlexChild>
                    <FlexChild height={"initial"} padding={mainPadd}>
                        {/* 검색 창 */}
                        <AdminMobileSearchInput placeholder="공지 명, 기간을 검색해보세요." onSearch={handleSearchChange} />
                    </FlexChild>
                    <FlexChild>
                        {/* 공지 관리 리스트 */}
                        <AdminMobileNoticeList notices={filteredNotice} updateNotice={handleUpdateNoticeList} />
                    </FlexChild>
                </VerticalFlex>
                {/* 등록 페이지 이동 버튼 */}
                <AdminMobileRegisterBtn to="/admin/mobile/notice/register" />
            </Container>
        </div>
    );
};

export default AdminMobileStoreNotice;